import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { BroadcastStateService } from '../services/broadcaststate/BroadcastStateService';
import { ScheduleService } from '../services/schedule/ScheduleService';
import { assert } from '../utils/assert';
import { parseBroadcastFromUrl } from '../utils/url';
export function useActiveBroadcastController() {
    const location = useLocation();
    // biome-ignore lint/correctness/useExhaustiveDependencies: we read the URL from window.location.href, not from via location object
    useEffect(() => {
        const broadcast = parseBroadcastFromUrl(new URL(window.location.href));
        assert(broadcast, 'No broadcast in URL');
        const scheduledBroadcast = ScheduleService.getInstance().getScheduledBroadcast(broadcast.streamId);
        const roleProperties = scheduledBroadcast !== undefined
            ? {
                myRole: 'broadcaster',
                broadcasterPrivateKey: scheduledBroadcast.broadcasterPrivateKey,
            }
            : {
                myRole: 'viewer',
            };
        BroadcastStateService.getInstance().notifySetActiveBroadcast({
            ...broadcast,
            ...roleProperties,
        });
    }, [location.key]);
    useEffect(() => {
        return () => {
            BroadcastStateService.getInstance().notifySetActiveBroadcast(undefined);
        };
    }, []);
}
